import { HttpPostRequest } from '@infrastructure/axios/http-post-request';
import { IUserSessionRespository } from '@infrastructure/persistance/user-session';

export type RefreshTokenResponse = { token: string };
export type RefreshTokenPayload = { refreshToken: string };

export default class RefreshTokenUseCase extends HttpPostRequest<RefreshTokenPayload, RefreshTokenResponse> {
  constructor(private sessionReporsitory: IUserSessionRespository) {
    super();
  }

  public async execute(): Promise<void> {
    const refreshToken = await this.sessionReporsitory.getRefreshToken();

    if (!refreshToken) return;

    const { data } = await this.dispatch('/auth/refresh', { refreshToken });
    const newToken = data.data;

    this.sessionReporsitory.saveToken(newToken.token);
  }
}
